<template>
  <section class="contact-section">
    <div class="container">
      <a-row :gutter="72">
        <a-col :sm="15">
          <ContactForm :mail-to="mailTo" :description="description" />
        </a-col>
        <a-col :sm="9">
          <AdditionalInfo :info-data="infoData" />
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script>
import ContactForm from "./contact-form";
import AdditionalInfo from "./additional-info";

export default {
  name: "ContactSection",
  components: {
    ContactForm,
    AdditionalInfo
  },
  props: {
    description: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    infoData: {
      type: String,
      default: ""
    },
    mailTo: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss"></style>
